const getEnemyPlayer = (player) => (player === 'player1' ? 'player2' : 'player1');
export default getEnemyPlayer;
